import React from "react";
import { FiBell, FiAlertTriangle, FiAlertCircle, FiShield, FiUser, FiCalendar } from "react-icons/fi";
import Modal from "../Modal/Modal";
import { TrescHtml } from "../common/OknoBramki/OknoBramki";
import { htmlDokumentuNaEkran } from "../common/EdytorTresci/TrescDokumentu";
import { normAnnPriority, etykietaAnnPriority, etykietaWariantuPaska } from "../../utils/annPriority";
import { FILES_BASE_URL } from "../../api/apiService";
import styles from "./OknoPelnegoKomunikatu.module.css";

/**
 * [polecenie właściciela 2026-09-17, obszar 5] PEŁNA TREŚĆ KOMUNIKATU OTWARTA Z PASKA.
 *
 * Właściciel: „W pasku wyświetlaj tytuł, kategorię oraz 2 pierwsze linijki z opcją kliknięcia
 * do otwarcia w oknie modal."
 *
 * <b>Dlaczego osobne okno, a nie `AnnouncementModal`.</b> `AnnouncementModal` to BRAMKA: nie ma ✕,
 * nie ma `onClose` i zamyka się wyłącznie przyciskiem „Zapoznałem się z komunikatem", który
 * POTWIERDZA odczyt na serwerze. Otwarcie jej z paska znaczyłoby, że kliknięcie „przeczytaj
 * dalej" jednocześnie KASUJE pasek u wszystkich urządzeń tego konta — a właściciel poprosił
 * o podgląd, nie o potwierdzenie. Potwierdzenie paska ma dokładnie jedno miejsce: ✕ na pasku.
 *
 * To okno więc świadomie NIC NIE ZAPISUJE — dokładnie jak okno „wczytaj ponownie” w centrum
 * powiadomień (decyzja S16 z 2026-09-13).
 *
 * Zamyka się wyłącznie przez ✕ w nagłówku albo przycisk „Zamknij” (wspólny `Modal` — klik w tło
 * potrząsa oknem, zasada właściciela z 2026-09-08).
 */

const IKONY = {
    1: FiAlertTriangle,
    2: FiAlertCircle,
    99: FiShield,
};

const TONY = {
    1: "tonOstrzezenie",
    2: "tonKrytyczny",
    99: "tonRodo",
};

const dataCzas = (wartosc) => {
    if (!wartosc) return "";
    const d = new Date(wartosc);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleString("pl-PL", { day: "2-digit", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

/**
 * [2026-10-04] Treść paska jest od teraz ZWYKŁYM TEKSTEM (pole tekstowe w edytorze, serwer odrzuca znaczniki).
 * Tekst wstawiony do okna jako HTML zlałby akapity w jeden blok i potraktował „<” jak początek znacznika —
 * dlatego tekst bez znaczników zamieniamy na akapity z zakodowanymi znakami. Stare paski pisane edytorem
 * z formatowaniem (mają znaczniki) idą jak dotąd.
 */
export const trescDoOkna = (tresc) => {
    const t = String(tresc || "");
    if (/<\/?[a-zA-Z]/.test(t)) return t;
    const koduj = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    return t.split(/\r?\n/).map((l) => l.trim()).filter(Boolean).map((l) => `<p>${koduj(l)}</p>`).join("");
};

const OknoPelnegoKomunikatu = ({ komunikat, onClose }) => {
    if (!komunikat) return null;

    const priorytet = normAnnPriority(komunikat.priority);
    const Ikona = IKONY[priorytet] || FiBell;
    const tonKlasa = styles[TONY[priorytet]] || "";
    const obrazek = komunikat.imagePath ? `${FILES_BASE_URL}/${komunikat.imagePath}` : null;

    return (
        <Modal isOpen onClose={onClose} title={komunikat.title} width="760px">
            <div className={styles.cialo} data-okno-komunikatu={komunikat.id}>
                <div className={styles.metaRzad}>
                    <span className={`${styles.kategoria} ${tonKlasa}`} data-kategoria-komunikatu>
                        <Ikona size={13} aria-hidden="true" />
                        {komunikat.isTopBar ? etykietaWariantuPaska(komunikat.priority) : etykietaAnnPriority(komunikat.priority)}
                    </span>
                    {komunikat.authorName ? (
                        <span className={styles.metaPozycja}><FiUser size={12} aria-hidden="true" />{komunikat.authorName}</span>
                    ) : null}
                    {komunikat.createdAt ? (
                        <span className={styles.metaPozycja}><FiCalendar size={12} aria-hidden="true" />{dataCzas(komunikat.createdAt)}</span>
                    ) : null}
                </div>

                {/* Podgląd nie potwierdza zapoznania się — mówimy to wprost, żeby nikt nie szukał
                    przycisku potwierdzenia, którego tu celowo nie ma. */}
                <p className={styles.nota}>
                    {komunikat.topBarDismissible === false
                        ? "Tego paska nie da się zamknąć — zniknie sam, gdy skończy się okres jego wyświetlania."
                        : "Podgląd nie potwierdza zapoznania się — pasek zamykasz przyciskiem ✕ na samym pasku."}
                </p>

                {obrazek && (
                    <div className={styles.obrazek}>
                        <img src={obrazek} alt="Załącznik komunikatu" onError={(e) => { e.target.style.display = "none"; }} />
                    </div>
                )}

                <div className={styles.tresc}>
                    <TrescHtml html={htmlDokumentuNaEkran(trescDoOkna(komunikat.content))} />
                </div>

                <div className={styles.stopka}>
                    <button type="button" className={styles.przyciskZamknij} onClick={onClose}>
                        Zamknij
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default OknoPelnegoKomunikatu;
